import React, { useState, useEffect, Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import MainPagetitle from "../../layouts/MainPagetitle";
import ClipLoader from "react-spinners/ClipLoader";
import "react-datepicker/dist/react-datepicker.css";
import "../../pages/Subdivision/subdivisionList.css";
import PaymentOffcanvas from "./PaymentOffcanvas";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AdminPaymentService from "../../../API/Services/AdminService/AdminPaymentService";
const stripePromise = loadStripe(process.env.REACT_APP_PK_KEY);

const PaymentList = () => {
  const navigate = useNavigate();
  const [paymentList, setPaymentList] = useState([]);
  const [canvasShowAdd, seCanvasShowAdd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      getPaymentList();
    } else {
      navigate("/");
    }
  }, []);

  const columnsName = [
    { label: "Brand", key: "Brand", id: 1 },
    { label: "Last 4 digit", key: "Last_digit", id: 2 },
    { label: "Expiry Month", key: "Exp_month", id: 3 },
    { label: "Expiry Year", key: "Exp_year", id: 4 },
    { label: "Set as default", key: "", id: 5 },
    // { label: "", key: "Exp_year", id: 6 },
    { label: "Action", key: "Action", id: 6 },
  ];

  const getPaymentList = async () => {
    setIsLoading(true);
    try {
      const response = await AdminPaymentService.index();
      const responseData = await response.json();
      setIsLoading(false);
      setPaymentList(responseData?.cards);
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };

  const handleDelete = async (id) => {
    const payload = {
      payment_method_id: id,
    };

    try {
      let responseData = await AdminPaymentService.destroy(payload).json();

      if (responseData) {
        getPaymentList();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleCallback = () => {
    getPaymentList();
  };

  const handleDefaultAdd = async (id) => {
    setIsLoading(true);
    const payload = {
      payment_method_id: id,
    };

    try {
      let responseData =
        await AdminPaymentService.detDefaultCard(payload).json();

      if (responseData) {
        swal("Default card select Successfully.");
        seCanvasShowAdd(false);
        setIsLoading(false);
        getPaymentList();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const capitalizeFirstLetter = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1);

  return (
    <Fragment>
      <MainPagetitle
        mainTitle="Payment"
        pageTitle="Payment"
        parentTitle="Home"
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center pb-0">
                    <div className="d-flex text-nowrap justify-content-between align-items-center">
                      <h4 className="heading mb-0">Payment List</h4>
                      <div
                        className="btn-group mx-5"
                        role="group"
                        aria-label="Basic example"
                      ></div>
                    </div>

                    <div className="mt-2" style={{ width: "100%" }}>
                      <div className="d-flex">
                        <Link
                          to={"#"}
                          className="btn btn-primary btn-sm ms-1"
                          data-bs-toggle="offcanvas"
                          onClick={() => seCanvasShowAdd(true)}
                        >
                          <div style={{ fontSize: "11px" }}>
                            <i className="fa fa-plus" />
                            &nbsp; Add Payment
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer mt-3"
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                      </div>
                    ) : (
                      <table
                        id="empoloyees-tblwrapper"
                        className="table ItemsCheckboxSec dataTable no-footer mb-0 landsale-table"
                      >
                        <thead>
                          <tr style={{ textAlign: "center" }}>
                            <th>
                              <strong> No. </strong>
                            </th>

                            {columnsName.map((column) => (
                              <th
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                                // key={column.id}
                              >
                                <strong>{column.label}</strong>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {paymentList !== null && paymentList?.length > 0 ? (
                            paymentList.map((element, index) => (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{capitalizeFirstLetter(element?.brand)}</td>
                                <td>{element?.last4}</td>
                                <td>{element?.exp_month}</td>
                                <td>{element?.exp_year}</td>
                                {/* <td>{element.is_default ? "Default" : ""}</td> */}
                                <td>
                                  {/* <Form.Check
                                    type="switch"
                                    id={`default-switch-${element.id}`}
                                    checked={
                                      element.is_default || element.isDefault
                                    }
                                    disabled={element.isDefault}
                                    onChange={() =>
                                      swal({
                                        title: "Are you sure?",
                                        icon: "warning",
                                        buttons: true,
                                        dangerMode: true,
                                      }).then((willDelete) => {
                                        if (willDelete) {
                                          handleDefaultAdd(element?.id);
                                        }
                                      })
                                    }
                                  /> */}
                                  <div className="form-check form-switch d-flex justify-content-center">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id={`default-switch-${element.id}`}
                                      checked={
                                        element.is_default || element.isDefault
                                      }
                                      disabled={element.isDefault}
                                      onChange={() =>
                                        handleDefaultAdd(element?.id)
                                      }
                                    />
                                  </div>
                                </td>
                                <td
                                  // key={column.id}
                                  style={{ textAlign: "center" }}
                                >
                                  <div className="d-flex justify-content-center">
                                    <Link
                                      onClick={() =>
                                        swal({
                                          title: "Are you sure?",
                                          icon: "warning",
                                          buttons: true,
                                          dangerMode: true,
                                        }).then((willDelete) => {
                                          if (willDelete) {
                                            handleDelete(element?.id);
                                          }
                                        })
                                      }
                                      className="btn btn-danger shadow btn-xs sharp"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="17" style={{ textAlign: "center" }}>
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Elements stripe={stripePromise}>
        <PaymentOffcanvas
          canvasShowAdd={canvasShowAdd}
          seCanvasShowAdd={seCanvasShowAdd}
          Title="Add Payment"
          parentCallback={handleCallback}
        />
      </Elements>
    </Fragment>
  );
};

export default PaymentList;
